export default __webpack_public_path__ + "static/media/Camion3-t.1cec5d8e.png";